import { render, staticRenderFns } from "./PriceEditDialog.vue?vue&type=template&id=bbd35c6c&scoped=true"
import script from "./PriceEditDialog.vue?vue&type=script&lang=js"
export * from "./PriceEditDialog.vue?vue&type=script&lang=js"
import style0 from "./PriceEditDialog.vue?vue&type=style&index=0&id=bbd35c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd35c6c",
  null
  
)

export default component.exports